import { UserTypeEnum } from '@app/enum/UserTypeEnum';
import { createSelector } from '@ngrx/store';
import { LoginStoreModule } from './login-store.module';

export const selectItems = (state: LoginStoreModule) => (state.User ? state.User : null);

export const getUserPremiumStatus = createSelector(selectItems, (allItems) => {
  {
    if (allItems != null && allItems['data']) {
      let premium_status = allItems['data']['premium_status'];
      if (premium_status == 'subscribed' || premium_status == 'cancelAtPeriodEnd' || premium_status == 'subscribedByProfessional') {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }
});

export const getUseIsproefessional = createSelector(selectItems, (allItems) => {
  {
    if (allItems != null && allItems['data']) {
      if (allItems['data']['user_type'] == UserTypeEnum.Professional) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
});

export const getUseIsNormal = createSelector(selectItems, (allItems) => {
  {
    if (allItems != null && allItems['data']) {
      if (allItems['data']['user_type'] == UserTypeEnum.Professional) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }
});

export const getCurrentUserDetails = createSelector(selectItems, (allItems) => {
  {
    if (allItems != null && allItems['data']) {
      const currentUserDetails = {
        id: allItems.data.id,
        first_name: allItems.data.first_name,
        last_name: allItems.data.last_name,
        profile_image_url: allItems.data.profile_image_url,
      };

      return currentUserDetails;
    }
  }
});
export const getCurrentUserDetailsAll = createSelector(selectItems, (allItems) => {
  {
    if (allItems != null && allItems['data']) {
      try {
        let newDate;
        try {
          if (allItems?.data?.birthdate) {
            const tempdate = allItems.data.birthdate.split('-');
            if (tempdate.length > 2) {
              let date = new Date();
              date.setDate(tempdate[2]);
              date.setMonth(tempdate[1] - 1);
              date.setFullYear(tempdate[0]);
              newDate = date;
            }
          }
        } catch (error) {}
        const currentUserDetails = {
          org_image_url: allItems.data.org_image_url,
          id: allItems.data.id,
          first_name: allItems.data.first_name,
          last_name: allItems.data.last_name,
          middle_name: allItems.data.middle_name,
          name: allItems.data.name,
          your_self: allItems.data.your_self,
          nick_name: allItems.data.nick_name,
          first_middle_name: allItems.data.first_middle_name,
          email: allItems.data.email,
          user_type: allItems.data.user_type,
          birthdate: allItems.data.birthdate ? newDate : '',
          city: allItems.data.city,
          country: allItems.data.country,
          state: allItems.data.state,
          zip: allItems.data.zip,
          street: allItems.data.street,
          phone_no: allItems.data.phone_no,
          profile_image_url: allItems.data.profile_image_url,
          org_name: allItems.data.org_name,
          org_size: allItems.data.org_size,
          professional_type_id: allItems.data.professional_type_id,
          org_industries: allItems.data.org_industries,
          gender: allItems.data.gender,
          contact_email: allItems.data.contact_email,
          mfa_enabled: allItems.data.mfa_enabled,
          residence_country: allItems.data.residence_country,
          residence_state: allItems.data.residence_state,
          account_setup_status: allItems.data.account_setup_status,
          ob_prompts_dns: allItems.data.ob_prompts_dns,
          security_and_privacy_complete: allItems.data.security_and_privacy_complete,
          intro_complete: allItems.data.intro_complete,
          onboarding_responsibility_complete: allItems.data.onboarding_responsibility_complete,
          prefix: allItems.data.prefix,
          suffix: allItems.data.suffix,
          has_passed_away: allItems.data.has_passed_away,
          has_passed_away_date: allItems.data.has_passed_away_date,
        };
        return currentUserDetails;
      } catch (error) {
        return allItems?.data ? allItems?.data : null;
      }
    } else {
      return allItems?.data ? allItems?.data : null;
    }
  }
});

export const getCurrentUserFullDetails = createSelector(selectItems, (allItems) => {
  {
    if (allItems != null && allItems['data']) {
      return allItems?.data;
    }
  }
});

export const getCurrentUserType = createSelector(selectItems, (allItems) => {
  {
    if (allItems != null && allItems['data']) {
      if (typeof allItems['data'].user_type === undefined) {
        return { isLoading: true, isProfessional: null };
      } else if (allItems['data'].user_type == UserTypeEnum.Professional) {
        return { isLoading: false, isProfessional: true };
      } else if (allItems['data'].user_type == UserTypeEnum.Standard) {
        return { isLoading: false, isProfessional: false };
      }
    }
  }
});
